import * as React from 'react';
import { Styled } from './styled';


interface Props {
  getContainerRef?: (ref: HTMLDivElement) => void;
  optionContainer?: boolean;
  zIndex?: number;
}

export class ContextMenu extends React.Component<Props> {

  public render(): React.ReactNode {
    const { getContainerRef, optionContainer, zIndex } = this.props;

    return (
      <Styled.Container
        optionContainer={optionContainer}
        ref={getContainerRef}
        className='context-menu'
        zIndex={zIndex}
      >
        {this.props.children}
      </Styled.Container>
    );
  }
}
